// HeaderMainPage
import React, { useState, useEffect } from 'react';
import aLotBLogo from '../assets/TestW.png';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PersonIcon from '@mui/icons-material/Person';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import MiniUserModal from '../containers/Header/MiniUserModal';
import { signout } from '../actions';
import CreateUser from '../components/modal/CreateUserModal';
import PasswordResetModal from '../components/modal/PasswordResetModal';
import { setShowPasswordResetModal } from '../reducers/auth.reducer';
import useSiteTheme from '../hooks/useSiteTheme';

const HeaderMainPage = ({ background, sticky = false }) => {
    const auth = useSelector((state) => state.auth);
    const { loading, showPasswordResetModal } = auth;
    const contactNumber = useSelector((state) => state.contact.contact[0]?.number);

    const [showMiniUserModal, setShowMiniUserModal] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [siteTheme, toggleSiteTheme, themeMeta] = useSiteTheme();
    const dark = themeMeta?.isDark || siteTheme === 'black' || siteTheme === 'dark' || siteTheme === 'dark-AO';

    useEffect(() => {
        if (showMiniUserModal || showPasswordResetModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showMiniUserModal, showPasswordResetModal]);

    const hrefNavigate = () => {
        navigate('/');
    };

    const logout = () => {
        dispatch(signout());
        setShowMiniUserModal(false);
    };

    const closeShowMiniModal = () => {
        setShowMiniUserModal(!showMiniUserModal);
    };

    const handleThemeClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowMiniUserModal(false);
        toggleSiteTheme();
    };

    return (
        <header className={`headerMainPage ${background ? "headerMainPage--solid" : ""} ${sticky ? "headerMainPage--sticky" : ""}`.trim()}>
            <div className="headerMainPage__container">
                <div className="headerMainPage__logo" onClick={hrefNavigate}>
                    <img src={aLotBLogo} alt="ALOTB Logo" />
                </div>

                <div className="headerMainPage__actions">
                    <button
                        type="button"
                        className="headerMainPage__themeBtn"
                        title={dark ? "Светлая тема" : "Тёмная тема"}
                        onClick={handleThemeClick}
                        disabled={themeMeta?.pending}
                        aria-label="Переключить тему"
                    >
                        {dark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
                    </button>

                    <button
                        type="button"
                        onClick={() => setShowMiniUserModal(!showMiniUserModal)}
                        className={`headerMainPage__profileBtn ${showMiniUserModal ? "active" : ""}`}
                    >
                        <span className="icon-circle">
                            <PersonIcon fontSize="small" />
                        </span>

                        <span className="text-label">
                            {auth.authenticate ? auth.user.firstName : "Профиль"}
                        </span>
                    </button>
                </div>
            </div>

            <MiniUserModal
                contactNumber={contactNumber}
                auth={auth.authenticate}
                user={auth.user}
                setShowMiniUserModal={setShowMiniUserModal}
                closeShowMiniModal={closeShowMiniModal}
                visible={showMiniUserModal}
                logout={logout}
                typeModal="rightModal"
            />

            <CreateUser loading={loading} />

            <PasswordResetModal
                visible={showPasswordResetModal}
                onClose={() => dispatch(setShowPasswordResetModal(false))}
            />
        </header>
    );
};

export default HeaderMainPage;
